import { dialog, focus, locale } from '../index';
import { beginSave, saveCompleted, saveError, exportDialog } from '../../workbook/common/event';
import { getComponent, isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * `Save` module is used to handle the save action in Spreadsheet.
 */
export class Save {
    /**
     * Constructor for Save module in Spreadsheet.
     *
     * @private
     * @param {Spreadsheet} parent - Specifies the Spreadsheet instance.
     */
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
        //Spreadsheet.Inject(WorkbookSave);
    }
    /**
     * To destroy the Save module.
     *
     * @returns {void}
     * @hidden
     */
    destroy() {
        this.removeEventListener();
        this.parent = null;
    }
    addEventListener() {
        this.parent.on(beginSave, this.initiateSave, this);
        this.parent.on(saveCompleted, this.saveCompleted, this);
        this.parent.on(saveError, this.showErrorDialog, this);
        this.parent.on(exportDialog, this.exportDialog, this);
    }
    removeEventListener() {
        if (!this.parent.isDestroyed) {
            this.parent.off(beginSave, this.initiateSave);
            this.parent.off(saveCompleted, this.saveCompleted);
            this.parent.off(saveError, this.showErrorDialog);
            this.parent.off(exportDialog, this.exportDialog);
        }
    }
    /**
     * Get the module name.
     *
     * @returns {string} - Get the module name.
     * @private
     */
    getModuleName() {
        return 'save';
    }
    /**
     * Initiate save process.
     *
     * @hidden
     * @returns {void} - Initiate save process.
     */
    initiateSave() {
        this.parent.showSpinner();
    }
    /**
     * Save action completed.
     *
     * @hidden
     * @returns {void} - Save action completed.
     */
    saveCompleted() {
        this.parent.hideSpinner();
    }
    showErrorDialog(args) {
        const dialogInst = this.parent.serviceLocator.getService(dialog);
        dialogInst.show({
            isModal: true, showCloseIcon: true, height: 180, width: 400, content: args.content,
            beforeOpen: () => focus(this.parent.element)
        });
    }
    exportDialog(args) {
        const l10n = this.parent.serviceLocator.getService(locale);
        const dialogInst = this.parent.serviceLocator.getService(dialog);
        const type = args ? args.item.id.split(this.parent.element.id + '_')[1] : 'xlsx';
        if (isNullOrUndefined(this.parent.element.querySelector('.e-open-dlg'))) {
            const dlg = {
                isModal: true, showCloseIcon: true, cssClass: 'e-open-dlg',
                header: l10n.getConstant('SaveAs'),
                enableRtl: this.parent.enableRtl,
                beforeOpen: (args) => {
                    const dlgArgs = {
                        dialogName: l10n.getConstant('SaveAs'),
                        element: args.element, target: args.target, cancel: args.cancel
                    };
                    this.parent.trigger('dialogBeforeOpen', dlgArgs);
                    if (dlgArgs.cancel) {
                        args.cancel = true;
                    }
                    else {
                        dialogInst.dialogInstance.content = this.OpenContent(type);
                        dialogInst.dialogInstance.dataBind();
                        this.parent.element.querySelector('.e-text-open').setSelectionRange(0, this.parent.element.querySelector('.e-text-open').value.length);
                        focus(this.parent.element);
                    }
                },
                buttons: [{
                        buttonModel: {
                            content: l10n.getConstant('Save'), isPrimary: true, cssClass: 'e-btn-open-ok'
                        },
                        click: () => {
                            const name = this.parent.element.querySelector('.e-text-open').value;
                            if (this.checkValidName(name)) {
                                dialogInst.hide();
                                const type = args ? args.item.id.split(`${this.parent.element.id}_`)[1] : 'Xlsx';
                                this.parent.save({ saveType: type, fileName: name });
                            }
                            else {
                                const saveButton = this.parent.element.querySelector('.e-btn-open-ok');
                                const saveButtonObj = getComponent(saveButton, 'btn');
                                saveButtonObj.disabled = true;
                                const l10n = this.parent.serviceLocator.getService(locale);
                                const error = name.length === 0 ? l10n.getConstant('EmptyFileName') :
                                    (name.length > 218 ? l10n.getConstant('LargeName') : l10n.getConstant('FileNameError'));
                                const fileSpan = this.parent.createElement('span', { className: 'e-file-alert-span' });
                                fileSpan.innerText = error;
                                if (this.parent.element.querySelector('.e-file-alert-span')) {
                                    this.parent.element.querySelector('.e-file-alert-span').remove();
                                }
                                (this.parent.element.querySelector('.e-open-dlg').querySelector('.e-dlg-content')).appendChild(fileSpan);
                            }
                        }
                    }]
            };
            dialogInst.show(dlg);
        }
        else {
            dialogInst.hide();
        }
    }
    checkValidName(name) {
        let isValidName = true;
        if (name.match(new RegExp('.*[\\[\\]\\*\\\\/\\?\\:\\<\\>\\|\\"].*')) || name.length < 1 || name.length > 218) {
            isValidName = false;
        }
        return isValidName;
    }
    OpenContent(type) {
        const l10n = this.parent.serviceLocator.getService(locale);
        const dialogElem = this.parent.createElement('div', { className: 'e-open-dialog' });
        const openTextHeader = this.parent.createElement('div', { className: 'e-open-head' });
        const openTextE = this.parent.createElement('div', { className: 'e-input-group' });
        dialogElem.appendChild(openTextHeader);
        dialogElem.appendChild(openTextE);
        const header = l10n.getConstant('FileName');
        const id = `${this.parent.element.id}_filename`;
        const openTextH = this.parent.createElement('p', { className: 'e-header', id: id, attrs: { 'aria-label': `${l10n.getConstant('SaveAs')} ${header}` } });
        openTextH.innerText = header;
        const openTextIp = this.parent.createElement('input', { className: 'e-input e-text-open', attrs: { 'type': 'Text', 'aria-labelledby': id } });
        const openTextSpan = this.parent.createElement('span', { className: 'e-input-group-icon' });
        openTextIp.onkeyup = (e) => {
            if (this.parent.element.querySelector('.e-file-alert-span') && e.keyCode !== 13) {
                const saveButton = this.parent.element.querySelector('.e-btn-open-ok');
                const buttonObj = getComponent(saveButton, 'btn');
                buttonObj.disabled = false;
                this.parent.element.querySelector('.e-file-alert-span').remove();
            }
        };
        openTextHeader.appendChild(openTextH);
        openTextSpan.textContent = '.' + type.toLowerCase();
        openTextE.appendChild(openTextIp);
        openTextIp.setAttribute('value', 'Sample');
        openTextE.appendChild(openTextSpan);
        return dialogElem;
    }
}
